import { jsx as _jsx } from "react/jsx-runtime";
import TalentReviewNineBoxSetting from "../../components/TalentReview/TalentReviewNineBoxSettings";
var TalentReviewNineBoxSettingsPage = function () {
    return _jsx(TalentReviewNineBoxSetting, {});
};
export default TalentReviewNineBoxSettingsPage;
